export interface ReturnFetchData<T> {
  items: T[];
  totalResults: number;
  nextPage: number | null;
}

export async function paginatedFetch<T>(
  endpoint: string,
  limit: number,
  page: number,
  contentType?: string
): Promise<ReturnFetchData<T>> {
  const skip = page * limit;
  const hasQuery = endpoint.includes("?");
  const response = await fetch(
    `${endpoint}${hasQuery ? "&" : "?"}limit=${limit}&skip=${skip}${contentType ? `&contentType=${contentType}` : ""}`
  );
  const { data, message } = await response.json();
  if (typeof data === "undefined") throw new Error(message || "Failed to retrieve collection data");

  const totalItemsSoFar = page * limit + data.items.length;

  return {
    items: data.items,
    totalResults: data.total,
    nextPage: totalItemsSoFar >= data.total || data.items.length < limit ? null : page + 1,
  };
}

export async function fetchByEndpoint<T>(endpoint: string): Promise<T> {
  const response = await fetch(endpoint);
  const { data, message } = await response.json();
  if (typeof data === "undefined") throw new Error(message || `Failed to fetch from ${endpoint}`);
  return data;
}
